import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CircleIcon from '@mui/icons-material/Circle';

type passwordProps = {
  password: string;
};

const PASSWORD_VALIDATIONS = [
  {
    label: 'Be at least eight characters long',
    regex: /^.{8,}$/,
  },
  {
    label: 'Include one uppercase letter',
    regex: /[A-Z]+/,
  },
  {
    label: 'Include one number or special character',
    regex: /[\W\d]+/,
  },
];

const PasswordListItem = ({
  children,
  isValid,
}: {
  children: React.ReactNode;
  isValid: boolean;
}) => (
  <ListItem
    disablePadding
    sx={(theme) => ({
      position: 'relative',
      paddingLeft: '1rem',
      marginTop: 1,
      ...(isValid ? { listStyle: 'none', color: 'green.main' } : {}),
      [theme.breakpoints.down('sm')]: {
        marginLeft: '8px',
      },
    })}
  >
    {isValid && (
      <CheckIcon
        fontSize="inherit"
        sx={{
          position: 'absolute',
          right: '97%',
          top: '20%',
          marginRight: '4px',
        }}
      />
    )}
    {!isValid && (
      <CircleIcon
        fontSize="inherit"
        sx={{
          width: '5px',
          height: '5px',
          position: 'absolute',
          right: '97%',
          top: '30%',
          marginRight: '8px',
        }}
      />
    )}
    {children}
  </ListItem>
);

const PasswordValidations = ({ password }: { password: string }) => (
  <>
    <Box paddingTop={2}>Your password must:</Box>
    <List sx={{ paddingTop: 0 }}>
      {PASSWORD_VALIDATIONS.map(({ label, regex }) => (
        <PasswordListItem key={label} isValid={regex.test(password)}>
          {label}
        </PasswordListItem>
      ))}
    </List>
  </>
);

export const passwordRegexEval = (password: string) =>
  PASSWORD_VALIDATIONS.every(({ regex }) => regex.test(password));

export const PasswordRequirements = ({ password }: passwordProps) => {
  return (
    <>
      <Typography component="div" variant="textSmall">
        <PasswordValidations password={password} />
      </Typography>
    </>
  );
};
